var map = {
	"./customer10_BR1_1.json": 7768,
	"./customer10_BR3_1.json": 1366,
	"./customer10_BR7_1.json": 3288,
	"./customer1_BR1_1.json": 1472,
	"./customer1_BR3_1.json": 2663,
	"./customer1_BR7_1.json": 3810,
	"./customer2_BR1_1.json": 1339,
	"./customer2_BR3_1.json": 9905,
	"./customer2_BR7_1.json": 4814,
	"./customer5_BR1_1.json": 8555,
	"./customer5_BR2_1.json": 6613,
	"./customer5_BR3_1.json": 1421,
	"./customer5_BR4_1.json": 6480,
	"./customer5_BR5_1.json": 8134,
	"./customer5_BR6_1.json": 396,
	"./customer5_BR7_1.json": 7992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8295;